import { FC } from 'react';

import { RichTooltipAggrid } from '@mint-lib/tw-components';

type Props = {
  children: React.ReactNode;
};
export const InfoTooltip: FC<Props> = ({ children }) => {
  return <RichTooltipAggrid type="info">{children}</RichTooltipAggrid>;
};
